import { PropsWithChildren, useCallback, useState } from "react"
import styled from "styled-components"
import { Typography } from "../typography"
import { ChevronDownIcon } from "../icons"
import { theme } from "../provider"

const DescriptionMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const MoreContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

const ChevronContainer = styled.div<{ $isOpen: boolean }>`
  rotate: ${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")};
  transition: all 0.2s ease-in-out;
`

const MoreTextContainer = styled.div<{ $isOpen: boolean }>`
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  max-height: ${({ $isOpen }) => ($isOpen ? "500px" : "0")};
  overflow: hidden;
  transition:
    opacity 0.3s ease,
    max-height 0.3s ease;
`

export const DescriptionMore = ({
  children,
  isOpenByDefault,
  seeMoreText,
}: PropsWithChildren<{ isOpenByDefault?: boolean; seeMoreText: string }>) => {
  const [isOpen, setIsOpen] = useState(!!isOpenByDefault)

  const toggle = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation()
      e.preventDefault()
      setIsOpen((prev) => !prev)
    },
    [setIsOpen],
  )

  return (
    <DescriptionMoreContainer>
      <MoreContainer $isOpen onClick={toggle}>
        <ChevronContainer $isOpen={isOpen}>
          <ChevronDownIcon height={"18px"} color={theme.colors.majorelle} />
        </ChevronContainer>
        <Typography $variant={isOpen ? "caption-2" : "caption-2-link"} $color="majorelle">
          {seeMoreText}
        </Typography>
      </MoreContainer>
      <MoreTextContainer $isOpen={isOpen}>{children}</MoreTextContainer>
    </DescriptionMoreContainer>
  )
}
